import script from "./ProjectScheduleDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectScheduleDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProjectScheduleDetails.vue?vue&type=style&index=0&id=70b1dfb7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b1dfb7"]])

export default __exports__